import { colors } from 'ui/theme/colors';
import { SvgIcon, SvgIconProps } from '../SvgIcon';
import { getColor } from '../utils';

export const Campaigns = ({
  height = 24,
  width = 24,
  color = colors.grey90,
  isColorInherited = true,
  ...props
}: SvgIconProps) => (
  <SvgIcon
    data-temporary-fix
    data-test="campaigns-icon"
    height={height}
    width={width}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M8.32471 6.5C8.32471 6.01675 8.71646 5.625 9.19971 5.625H14.7997C15.2829 5.625 15.6747 6.01675 15.6747 6.5C15.6747 6.98325 15.2829 7.375 14.7997 7.375H9.19971C8.71646 7.375 8.32471 6.98325 8.32471 6.5Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M8.95947 8.625C8.47622 8.625 8.08447 9.01675 8.08447 9.5C8.08447 9.98325 8.47622 10.375 8.95947 10.375H14.9594C15.4427 10.375 15.8344 9.98325 15.8344 9.5C15.8344 9.01675 15.4427 8.625 14.9594 8.625H8.95947Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.11967 2.125C6.01884 2.125 5.04468 3.03972 5.04468 4.16803V10.8645L5.03091 10.8574C5.0161 10.85 5.00052 10.8414 4.96936 10.8234L4.96174 10.819C4.93483 10.8034 4.88403 10.774 4.83091 10.7474C4.68504 10.6745 4.49034 10.6051 4.2396 10.6051C3.86489 10.6051 3.48126 10.7197 3.18102 10.9926C2.87575 11.2701 2.72461 11.6515 2.72461 12.0401V19.8C2.72461 20.9232 3.67636 21.875 4.7996 21.875H19.1995C20.3227 21.875 21.2745 20.9232 21.2745 19.8V12.0401C21.2745 11.6328 21.0912 11.2544 20.8582 11.0214C20.6084 10.7715 20.2717 10.5973 19.908 10.5518C19.5516 10.5073 19.1316 10.587 18.7946 10.8903V4.16803C18.7946 3.03972 17.8204 2.125 16.7196 2.125H7.11967ZM17.0446 12.3301V4.16803C17.0446 4.12213 17.0223 4.04855 16.9493 3.97742C16.8765 3.90656 16.79 3.875 16.7196 3.875H7.11967C7.04926 3.875 6.96279 3.90656 6.88999 3.97742C6.81691 4.04855 6.79468 4.12213 6.79468 4.16803V12.2392L11.1137 15.6828C11.6711 16.1388 12.4071 16.1391 12.9647 15.6834L17.0446 12.3301ZM14.0751 17.036L19.5245 12.5571V19.8C19.5245 19.9567 19.3562 20.125 19.1995 20.125H4.7996C4.64285 20.125 4.47461 19.9567 4.47461 19.8V12.6276L10.0101 17.041C11.212 18.021 12.8728 18.0197 14.0736 17.0372L14.0751 17.036Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
